// Non usare i trattini perchè causano errori
export const TASKS_DESCRIBE: string = 'tasks';